interface CountBadgeProps {
  readonly count: number;
  readonly label: string;
  readonly className?: string;
}

export function CountBadge({ count, label, className = '' }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      aria-label={label}
      className={`inline-flex min-w-5 items-center justify-center rounded-full bg-debit px-1.5 text-xs font-medium text-paper tabular ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
